import { RootState, StateStatTags } from "@/store/types";
import { ActionTree, MutationTree } from "vuex";
import { ACTION_TYPES, MUTATION_TYPES } from "@/lib/const";
import providers from "@/lib/providers";

const { STORE_DATA } = MUTATION_TYPES;
const { GET_DATA } = ACTION_TYPES;
export const state = function(): StateStatTags {
  return {
    info: {},
  };
};

export const mutations: MutationTree<StateStatTags> = {
  [STORE_DATA]: (state, payload) => {
    state.info = payload.info;
  },
};

export const actions: ActionTree<StateStatTags, RootState> = {
  async [GET_DATA](context) {
    // @ts-ignore
    return providers.TagsProvider.getStats().then(r => {
      context.commit(STORE_DATA, r);
      return r;
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
